import { ProductTypeType } from './products'

export type StoreList = StoreSummary[]

export interface StoreSummary {
  id: number
  name: string
  region: string
}

export interface Store {
  accepts_mobile_orders: boolean
  address: string
  area: string
  bda_password: string
  city: string
  contentful_id: string
  email_address?: string
  id: number
  image_url: string
  latitude: string
  longitude: string
  minutes_to_closing_warning: number
  name: string
  netsuite_id: string
  phone: string
  postal_code: string
  region: string
  square_id: string
  state: string
  time_zone: TimeZone
  has_drive_thru: boolean
  drive_thru_online: boolean
  operating_state: OperatingState
  restrict_offline_access: boolean

  // Order throttling
  cups_per_barista: number
  max_bags_in_cart: number
  max_cups_in_cart: number
  max_food_items_in_cart: number
  max_merchandise_in_cart: number
  max_prep_time: number
  max_togo_in_cart: number
  order_time_slot_minutes: number

  // Deferred changes, keyed by field name
  pending_updates: Record<string, unknown> | null
}

export enum OperatingState {
  hidden = 'hidden',
  visible = 'visible',
}

type TimeZone =
  | 'America/Los_Angeles'
  | 'America/New_York'
  | 'America/Chicago'
  | 'America/Denver'
  | 'America/Phoenix'
  | 'America/Anchorage'
  | 'America/Adak'
  | 'America/Honolulu'

type AttributeType = {
  name: string
  product_type: ProductTypeType
}

export type AttributeValues = {
  id: number
  name: string
  attribute: AttributeType
  is_disabled: boolean
}

export type AttributeValuesRecord = Record<string, AttributeValues[]>
